<template>
    <div v-if="transaction.quantity >=0">
        <span class="label label-light-green font-weight-bold" v-if="transaction.from" title="Recieve">
            <i class="fa fa-sign-in-alt"/> RCV
        </span>
        <span class="label label-dark-green font-weight-bold" v-else title="Add">
            <i class="fa fa-plus-square"/> ADD
        </span>
    </div>
    <div v-else>
        <span class="label label-brown font-weight-bold" v-if="transaction.to" title="Transfer">
             <i class="fa fa-sign-out-alt"/> TRF
        </span>
        <template v-else>
            <template v-if="transaction.challan_id">
                <span class="label label-inverse font-weight-bold" title="Challan">
                    <i class="fa fa-clipboard-list"/> CHN
                </span>
            </template>
            <template v-else>
                <span class="label label-danger font-weight-bold" title="Deduct">
                    <i class="fa fa-minus-square"/> DED
                </span>
            </template>
        </template>
    </div>
</template>

<script>
export default {
    name: "WarehouseTransactionStatus",
    props: ["transaction"]
}
</script>

<style scoped>

</style>
